<template>
    <div
        ref="node"
        :id="object._id"
        class="agNode"
        :class="{'agNode-selected': isSelected, 'agNode-readonly': isReadonly}"
        :style="{
                'left': x,
                'top': y,
                'height': height,
                'background-color': color
            }">
        <div class="agNode-label agNode-shortLabel" :style="{'line-height': height}">{{object.shortname}}</div>
        <div class="agNode-label agNode-longLabel" :style="{'line-height': height}" v-b-tooltip.hover :title="tooltip">{{object.name}}</div>
        <div v-if="errors" class="agNode-errors" @click="errors_click" @dblclick="errors_dblclick">
            <fa v-if="errors.length > 0" class="agNode-errorsIcon" icon="exclamation-circle"/>
            <fa v-else-if="warnings.length > 0" class="agNode-warningsIcon" icon="exclamation-triangle"/>
        </div>
        <div class="agNode-breakpoint" v-if="isBreakpoint && object.shortname.charAt(0) !== 'V'"></div>
    </div>
</template>


<script>

// components


// modules
import Util from "src/util/util";

export default {
    name: "ag-node",

    props: {
        isSelected: Boolean,
        isReadonly: Boolean,
        isBreakpoint: Boolean,
        type: String,
        object: Object,
        errors: Array,
        warnings: Array,
    },

    components: {

    },

    data(){
        return {
            tooltip: ""
        };
    },

    computed: {

        x() {
            if(this.object && this.object.x)
                return this.object.x + "px";
            return "25px";
        },

        y() {
            if(this.object && this.object.y)
                return this.object.y + "px";
            return "50px";
        },

        height() {
            if(this.type == "switch" && this.object.cases.length > 0) {
                let height = 40 + 20*(this.object.cases.length - 1) + "px";
                return height;
            }
            if(this.type == "splitNode" && this.object.paths.length > 0) {
                let height = 40 + 20*(this.object.paths.length - 1) + "px";
                return height;
            }
            if(this.type == "compareNode") {
                let nDest = 0;
                if(this.object.dest_equal)
                    nDest++;
                if(this.object.dest_diff)
                    nDest++;
                if(this.object.dest_aNotB)
                    nDest++;
                if(this.object.dest_bNotA)
                    nDest++;
                let height = (40 + (20*nDest)).toString() + "px";
                return height;
            }
            if(this.type == "input") {
                let nDest = 0;
                if(this.object.dest_noResults)
                    nDest++;
                if(this.object.dest_error)
                    nDest++;
                let height = (40 + (20*nDest)).toString() + "px";
                return height;
            }
            if(this.type == "output") {
                let nDest = 0;
                if(this.object.dest_error)
                    nDest++;
                let height = (40 + (20*nDest)).toString() + "px";
                return height;
            }
            return "40px";
        },

        color() {
           return this.$store.getters["nodeStore/getColor"](this.type);
        }
    },

    mounted() {

        // set tooltip
        if(this.$refs.node.clientWidth >= 250)
        {
            this.tooltip = this.object.name;
        }
    },

    methods: {

        // UI Events

        errors_click() {
            this.$emit("showErrors");
        },

        errors_dblclick(e) {
            e.stopPropagation();
        },

        // emitted events



        // other

    }
}


</script>


<style scoped lang="css">

.agNode {
    position: absolute;
    cursor: grab;
    min-width: 95px;
    max-width: 250px;
    border-radius: 5px;
    opacity: 0.9;
    z-index: 1;
    background-color: #CDC1C5;
}

.agNode-selected {
    box-shadow: 0px 0px 7.5px 7.5px #ff0000;
}

.agNode-readonly {
    cursor: default;
}

.agNode:active {
    cursor: grabbing;
}

.agNode-readonly:active {
    cursor: default;
}

.agNode-label {
    font-weight: bold;
    color: #FFFFFF;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
}

.agNode-shortLabel {
    float: left;
    padding:0px 15px;
    height: 100%;

    border-right-style: solid;
    border-right-width: 1px;
}

.agNode-longLabel {
    padding: 0px 15px;
    height: 100%;
}

.agNode-errors {
    position: absolute;
    right: -14px;
    top: -17.5px;
    font-size: 20px;
    cursor: pointer;
    z-index: 4;
}

.agNode-errorsIcon {
    color: #DC3545;
}

.agNode-errorsIcon:hover {
    color: #C82333;
}


.agNode-warningsIcon {
    color: #ffd40f;
}

.agNode-warningsIcon {
    color: #ebc30e;
}
.agNode-breakpoint {
  height: 10px;
  width: 10px;
  background-color: #DC3545;
  border-radius: 50%;
  padding: 5px;
  display: inline-flex;
}
</style>



// WEBPACK FOOTER //
// src/components/nodes/Node.vue